module.exports = __webpack_public_path__ + "static/media/computerIcon.48a81985.svg";